import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const BASE_URL = 'https://medianov.com';
const DEFAULT_IMAGE = `${BASE_URL}/medinov.png`;

const PAGE_SEO = {
  '/': {
    title: 'Media Nov – Music Distribution, Publishing & Rights Management',
    description:
      'Share your music with the world with Media Nov! Protect your copyrights, maximize your earnings, and take your music career to the next level. Your trusted partner for digital distribution, publishing, rights management, and more.',
  },
  '/services': {
    title: 'Music Services – Distribution, Publishing & Rights | Media Nov',
    description:
      'Explore Media Nov services: digital distribution, rights management, artist development, music publishing, playlist pitching, and sync licensing.',
  },
  '/about': {
    title: 'About Media Nov – Empowering Artists Worldwide',
    description:
      'Learn about Media Nov, a global music distribution and publishing company helping independent artists protect rights and grow their careers.',
  },
  '/resources': {
    title: 'Music Industry Resources & Guides | Media Nov',
    description:
      'Access educational materials, legal documents, industry trends, production tips, and financial planning resources for music professionals.',
  },
  '/contact': {
    title: 'Contact Media Nov – Get in Touch',
    description:
      'Contact Media Nov for music distribution, publishing, and rights management. Reach our team in the USA and globally.',
  },
  '/physical-distribution': {
    title: 'Physical Music Distribution – CD & Vinyl | Media Nov',
    description:
      'Professional CD, vinyl, and cassette manufacturing, warehousing, and global physical distribution for artists and labels.',
  },
  '/music-publishing': {
    title: 'Music Publishing Services | Media Nov',
    description:
      'Media Nov music publishing services connect your catalog with global partners including Sony Music, ASCAP, Spotify, and more.',
  },
  '/artist-services': {
    title: 'Artist Services – PR, Marketing & Career Development | Media Nov',
    description:
      'Career development, PR, content creation, social media, playlisting, and marketing services for independent artists.',
  },
  '/copyright-report': {
    title: 'Report Copyright Violation | Media Nov',
    description:
      'Report a copyright violation to Media Nov. Submit details about unauthorized use of your music for prompt review.',
  },
};

const upsertMeta = (attribute, key, content) => {
  if (!content) return;

  let element = document.head.querySelector(`meta[${attribute}="${key}"]`);
  if (!element) {
    element = document.createElement('meta');
    element.setAttribute(attribute, key);
    document.head.appendChild(element);
  }
  element.setAttribute('content', content);
};

const upsertCanonical = (href) => {
  let element = document.head.querySelector('link[rel="canonical"]');
  if (!element) {
    element = document.createElement('link');
    element.setAttribute('rel', 'canonical');
    document.head.appendChild(element);
  }
  element.setAttribute('href', href);
};

const SeoHead = () => {
  const { pathname } = useLocation();
  const seo = PAGE_SEO[pathname] || {
    title: 'Page Not Found | Media Nov',
    description: 'The page you are looking for could not be found on Media Nov.',
  };
  const canonical = `${BASE_URL}${pathname === '/' ? '' : pathname}`;

  useEffect(() => {
    document.title = seo.title;
    upsertMeta('name', 'description', seo.description);
    upsertMeta('property', 'og:title', seo.title);
    upsertMeta('property', 'og:description', seo.description);
    upsertMeta('property', 'og:url', canonical);
    upsertMeta('property', 'og:image', DEFAULT_IMAGE);
    upsertMeta('name', 'twitter:title', seo.title);
    upsertMeta('name', 'twitter:description', seo.description);
    upsertMeta('name', 'twitter:image', DEFAULT_IMAGE);
    upsertCanonical(canonical);
  }, [pathname, seo.title, seo.description, canonical]);

  return null;
};

export default SeoHead;
